export default __webpack_public_path__ + "static/media/Audit_Report.4fe522d7.pdf";